/*
 * Google Enhanced Ecommerce Object
 *
 * Purchase logic for Google Enhanced Ecommerce.
 *
 * https://confluence.int.plus.net/display/DIGITAL/Google+Enhanced+Ecommerce
 */
const purchase = {

    /*
     * Initialise a purchase
     *
     * @param  {object} params Event variables
     * @returns  {void}
     */
    initialise: (params) => {

        if (
            gaEcommerce.purchase.isInitialised
            || !gaEcommerce.core.checkStorageCapabilities()
        ) return;

        const journey = gaEcommerce.core.getJourney();

        // DLIFE-791 - Prevent duplicate purchase events firing on page refresh
        if (
            sessionStorage.getItem('ecomPurchaseEventHasFired') !== journey
        ) {
            const storedProducts = sessionStorage.getItem('ecomProducts');

            try {
                const rawProducts = JSON.parse(storedProducts);
                let sanitisedProducts = rawProducts.map(JSON.parse);

                sanitisedProducts = gaEcommerce.purchase.removeDuplicates(sanitisedProducts);

                params.revenue = gaEcommerce.util.calculateTotalOrderPrice(sanitisedProducts);
                params.affiliation = gaEcommerce.core.getAffiliate();

                if (params.id === undefined) {
                    params.id = gaEcommerce.purchase.generateID();
                }

                // Include the journey name so we can identify where the checkout step came from
                params['dimension48'] = gaEcommerce.core.getJourney();

                const ecomData = gaEcommerce.purchase.buildEcomData(
                    {
                        actionField: params,
                        products: sanitisedProducts
                    }, storedProducts, null
                );

                if (gaEcommerce.core.sendData(ecomData, 'purchase')) {
                    // DLIFE-791 - Ensures that purchase events fire only once per journey
                    clientData.storage.setData(
                        {
                            name: 'ecomPurchaseEventHasFired',
                            value: journey
                        },
                        'sessionStorage'
                    );
                }

                sessionStorage.removeItem('ecomProducts');
            } catch (e) {
                gaEcommerce.core.sendData(
                    gaEcommerce.purchase.buildEcomData(null, storedProducts, e.message),
                    'purchaseFailed'
                );

            }
        }
    },

    /*
     * Removes any duplicate products
     *
     * @param  {array}  products
     * @returns  {array}
     */
    removeDuplicates: (products) => {

        const duplicateProducts = [],
              productNames = [];

        products.forEach((item, index) => {
            if (productNames.indexOf(item.name) !== -1) {
                // Remove it from the array sent in the purchase event
                products.splice(index, 1);

                // Remove it from the GA basket
                item.interaction = false;
                duplicateProducts.push(item);
            } else {
                productNames.push(item.name);
            }
        });

        if (duplicateProducts.length) {
            // Send list of removed products to GA
            gaEcommerce.core.sendRemoveData(duplicateProducts);

            // Save the basket with duplicates removed
            gaEcommerce.basket.saveBasket(products.map(JSON.stringify));
        }

        return products;

    },

    /*
     * Generate a unique ID
     *
     * @returns  {int}
     */
    generateID: () =>
        new Date().getTime()
    ,

    /*
     * Build debug data
     *
     * @param  {object}  ecomObject
     * @param  {object}  storedProducts
     * @param  {string}  error
     *
     * @returns {object}
     */
     buildEcomData: (ecomObject, storedProducts, error) => {
        // Check if the browser supports session storage
        const checkSessionStorage = () => {
            try {
                sessionStorage.setItem('test-key', 'test-value');
                if (sessionStorage.getItem('test-key') == 'test-value') {
                    sessionStorage.removeItem('test-key')
                    return true;
                }
            } catch (e) {
                return false;
            }
        }

        // Check if product list has products and JSON is valid
        let productsExist = false,
            isJsonValid = true;

        const testProductsList = () => {
            try {
                const storedProductsParsed = JSON.parse(storedProducts);

                if (Object.keys(storedProductsParsed).length > 0) {
                    productsExist = true;
                }
            } catch (e) {
                isJsonValid = false;
            }
        }

        testProductsList();

        var ecomInfo = {
            'ecomDebugInfo': {
                'purchaseFired': (ecomObject !== null),
                'supportsSessionStorage': checkSessionStorage(),
                'productsExist': productsExist,
                'isJsonValid': isJsonValid,
                'storedProducts': storedProducts,
                'jsError': error
            }
        }

        if (ecomObject !== null) {
            ecomInfo.purchase = ecomObject;
        }

        return ecomInfo;
    },

    /**
     * Reset purchase events
     *
     * Removes session storage flag to prevent duplicate purchase
     * events from firing. This enables purchase events to fire again 
     * when starting a new journey.
     *
     * @returns {void}
     */
    resetPurchaseEvents: () => {
        let steps = {};

        switch (gaEcommerce.core.getJourney()) {
            case 'broadband|sign-up|residential':
                steps = gaEcommerce.steps.resSignupSteps;
                break;
            case 'broadband|change-product|residential':
                steps = gaEcommerce.steps.legacyAccountChangeSteps;
                break;
        }

        const lastStep = steps[Object.keys(steps)[Object.keys(steps).length - 1]];

        if (gaEcommerce.steps.getFunnelStep(window.location.pathname) !== lastStep) {
            sessionStorage.removeItem('ecomPurchaseEventHasFired');
        }
    }
};

export default purchase;
